import { Form } from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  appTitle,
  Departement,
  EmployeeFollowUpEventQuizStatus,
  AnsweredBy,
  NotApplicableSuffix,
  ErrorSuffix,
  AnswerType,
  EmployeeSuffix,
} from "../common/GeneralConfigurations";
import {
  assignToSupervisor,
  getEmployeeFollowUpEventById,
  updateEmployeeFollowUpEvent,
} from "../../api/EmployeeFollowUpEventApi";
import {
  getQuizQuestionsAnswers,
  consultantQuizAnswers,
} from "../../api/QuizAPI/AnswerAPI";
import { GetUserByDepartmentId } from "../../api/UserApi";
import { getAuthenticatedUserId } from "../../api/ApiUtils";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import EmployeeFollowUpEventDetailListForm from "./EmployeeFollowUpEventDetailListForm";
import { AppRoutes } from "../../AppRoutes";

/** Supervisor Manager Page */
const ManageEmployeeFollowUpEventDetailListPage = () => {
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({
    id: null,
    employeeId: null,
    followUpEventId: null,
    date: undefined,
    feedBack: "",
    note: "",
    status: 0,
    doneById: null,
    quizStatusId: 0,
    companyLevel: null,
    clientLevel: null,
    projectLevel: null,
    employeeName: "",
    eventType: "",
    doneByName: "",
    authenticatedId: '00000000-0000-0000-0000-000000000000',
  });

  const { id } = useParams();
  const [formEvent] = Form.useForm();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [quizData, setQuizData] = useState(null);
  const [readonlyQuiz, setReadonlyQuiz] = useState(true);
  const [quizAnswersValues, setQuizAnswersValues] = useState({});
  const [isUserRH, setIsUserRH] = useState(false);
  const [disableSatisfactionLevel, setDisableSatisfactionLevel] =
    useState(true);
  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    document.title = `${appTitle} - ${t(
      "manageEmployeeFollowUpEventDetail.title"
    )}`;
  }, [t]);

  useEffect(async () => {
    if (id !== null) {
      await getEmployeeFollowUpEvent();
      await getUserData();
      await handleIsUserRH();
    }
    setLoading(false);
  }, []);

  useEffect(() => formEvent.resetFields(), [initValues]);

  const translateConsultantAndSupervisorQuestionAnswers = (data) => {
    const newQuestionAnswersValues = {};

    data &&
      data.groups.map((grp) => {
        grp.questions.map((qst) => {
          // only the supervisor answers the questions
          let name = `grp_${grp.id}_qst_${qst.id}`;
          const responses = data.questionAnswers.filter(
            (q) => q.questionId === qst.id
          );

          responses.map((qa) => {
            if (qa.isEmployeeAnswer === true) {
              // the answer given by the consultant/employee
              if (qst.answerTypeId === AnswerType.VerdadeiroFalso) {
                newQuestionAnswersValues[name.concat(EmployeeSuffix)] =
                  JSON.parse(qa.answer);
              } else if (
                qst.answerTypeId === AnswerType.Escala ||
                qst.answerTypeId === AnswerType.EscolhaUnica
              ) {
                newQuestionAnswersValues[name.concat(EmployeeSuffix)] =
                  +qa.answer;
              } else if (qst.answerTypeId === AnswerType.EscolhaMultipla) {
                if (qa.answer === null || qa.answer === undefined) {
                  newQuestionAnswersValues[name.concat(EmployeeSuffix)] =
                    undefined;
                } else {
                  const intArray = qa.answer
                    .split(",")
                    .map((id) => parseInt(id, 10));
                  newQuestionAnswersValues[name.concat(EmployeeSuffix)] =
                    intArray;
                }
              } else {
                newQuestionAnswersValues[name.concat(EmployeeSuffix)] =
                  qa.answer;
              }
              newQuestionAnswersValues[
                name.concat(EmployeeSuffix).concat(NotApplicableSuffix)
              ] = qa.isNotApplicable;
            } else {
              // the answer of the supervisor
              if (qst.answerTypeId === AnswerType.VerdadeiroFalso) {
                newQuestionAnswersValues[name] = JSON.parse(qa.answer);
              } else if (
                qst.answerTypeId === AnswerType.Escala ||
                qst.answerTypeId === AnswerType.EscolhaUnica
              ) {
                newQuestionAnswersValues[name] = +qa.answer;
              } else if (qst.answerTypeId === AnswerType.EscolhaMultipla) {
                if (qa.answer === null || qa.answer === undefined) {
                  newQuestionAnswersValues[name] = undefined;
                } else {
                  const intArray = qa.answer
                    .split(",")
                    .map((id) => parseInt(id, 10));
                  newQuestionAnswersValues[name] = intArray;
                }
              } else {
                newQuestionAnswersValues[name] = qa.answer;
              }
              newQuestionAnswersValues[name.concat(NotApplicableSuffix)] =
                qa.isNotApplicable;
              newQuestionAnswersValues[name.concat(ErrorSuffix)] = null;
            }
          });
        });
      });

    setQuizAnswersValues(newQuestionAnswersValues);
  };

  const translateQuestionAnswers = (data) => {
    const newQuestionAnswersValues = {};

    data &&
      data.groups.map((grp) => {
        grp.questions.map((qst) => {
          let name = `grp_${grp.id}_qst_${qst.id}`;
          let nameEmployee = `${name}${EmployeeSuffix}`;

          if (
            data.questionAnswers === null ||
            data.questionAnswers === undefined
          ) {
            newQuestionAnswersValues[name] = null;
            newQuestionAnswersValues[name.concat(NotApplicableSuffix)] = false;
            newQuestionAnswersValues[name.concat(ErrorSuffix)] = null;
            newQuestionAnswersValues[nameEmployee] = null;
            newQuestionAnswersValues[
              nameEmployee.concat(NotApplicableSuffix)
            ] = false;
          } else {
            const qaSupervisor = data.questionAnswers.find(
              (q) => q.questionId === qst.id && q.isEmployeeAnswer === false
            );
            const qaEmployee = data.questionAnswers.find(
              (q) => q.questionId === qst.id && q.isEmployeeAnswer === true
            );

            if (qaSupervisor === undefined) {
              newQuestionAnswersValues[name] = null;
              newQuestionAnswersValues[
                name.concat(NotApplicableSuffix)
              ] = false;
              newQuestionAnswersValues[name.concat(ErrorSuffix)] = null;
            } else {
              if (qst.answerTypeId === AnswerType.VerdadeiroFalso) {
                newQuestionAnswersValues[name] = JSON.parse(
                  qaSupervisor.answer
                );
              } else if (
                qst.answerTypeId === AnswerType.Escala ||
                qst.answerTypeId === AnswerType.EscolhaUnica
              ) {
                newQuestionAnswersValues[name] = +qaSupervisor.answer;
              } else if (qst.answerTypeId === AnswerType.EscolhaMultipla) {
                if (
                  qaSupervisor.answer === null ||
                  qaSupervisor.answer === undefined
                ) {
                  newQuestionAnswersValues[name] = undefined;
                } else {
                  const intArray = qaSupervisor.answer
                    .split(",")
                    .map((id) => parseInt(id, 10));
                  newQuestionAnswersValues[name] = intArray;
                }
              } else {
                newQuestionAnswersValues[name] = qaSupervisor.answer;
              }
              newQuestionAnswersValues[name.concat(NotApplicableSuffix)] =
                qaSupervisor.isNotApplicable;
              newQuestionAnswersValues[name.concat(ErrorSuffix)] = null;
            }

            if (qaEmployee === undefined) {
              newQuestionAnswersValues[nameEmployee] = null;
              newQuestionAnswersValues[
                nameEmployee.concat(NotApplicableSuffix)
              ] = false;
            } else {
              if (qst.answerTypeId === AnswerType.VerdadeiroFalso) {
                newQuestionAnswersValues[nameEmployee] = JSON.parse(
                  qaEmployee.answer
                );
              } else if (
                qst.answerTypeId === AnswerType.Escala ||
                qst.answerTypeId === AnswerType.EscolhaUnica
              ) {
                newQuestionAnswersValues[nameEmployee] = +qaEmployee.answer;
              } else if (qst.answerTypeId === AnswerType.EscolhaMultipla) {
                if (
                  qaEmployee.answer === null ||
                  qaEmployee.answer === undefined
                ) {
                  newQuestionAnswersValues[nameEmployee] = undefined;
                } else {
                  const intArray = qaEmployee.answer
                    .split(",")
                    .map((id) => parseInt(id, 10));
                  newQuestionAnswersValues[nameEmployee] = intArray;
                }
              } else {
                newQuestionAnswersValues[nameEmployee] = qaEmployee.answer;
              }
              newQuestionAnswersValues[
                nameEmployee.concat(NotApplicableSuffix)
              ] = qaEmployee.isNotApplicable;
            }
          }
        });
      });

    setQuizAnswersValues(newQuestionAnswersValues);
  };

  const getEmployeeFollowUpEvent = async () => {
    await getEmployeeFollowUpEventById(id)
      .then(async (res) => {
        if (res.status === 200) {
          res.data.date =
            res.data.date === null || res.data.date == undefined
              ? null
              : moment(res.data.date);

          setInitValues(res.data);

          enableSatisfactionLevel(res.data);
          if (
            res.data.quizStatusId !== EmployeeFollowUpEventQuizStatus.NoQuiz
          ) {
            await getQuizQuestionsAnswersInfo(res.data.id);
            // Quiz must be readonly when:
            // - quiz has been answered
            // - it's the supervisor viewing the quiz ant it's at state AwaitsResponseFromConsultant
            // - it's someone else but the supervisor viewing the quiz
            setReadonlyQuiz(
              res.data.quizStatusId !==
                EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor ||
                res.data.doneById != getAuthenticatedUserId()
            );
          } else {
            setQuizData(null);
          }
        } else {
          AdnMessageError(
            t("manageEmployeeFollowUpEventDetail.messages.errorGettingEvent")
          );
        }
      })
      .catch((e) => {
        AdnMessageError(
          t("manageEmployeeFollowUpEventDetail.messages.errorGettingEvent")
        );
      });
  };

  const enableSatisfactionLevel = (values) => {
    if (values.eventType.indexOf("Avaliação") >= 0) {
      setDisableSatisfactionLevel(true); // disable it
    } else if (values.eventType.indexOf("PDS Mensal") >= 0) {
      setDisableSatisfactionLevel(false); // not required
    } else {
      setDisableSatisfactionLevel(false); // required
    }
  };
  const getQuizQuestionsAnswersInfo = async (employeeFollowUpEventId) => {
    await getQuizQuestionsAnswers(employeeFollowUpEventId)
      .then((res) => {
        if (res.status === 200) {
          if (res.data) {
            setQuizData(res.data);

            if (
              res.data.dateAnswered !== null &&
              res.data.dateAnswered != undefined
            ) {
              translateConsultantAndSupervisorQuestionAnswers(res.data);
            } else {
              translateQuestionAnswers(res.data);
            }
          } else {
            AdnMessageError(
              t(
                "manageEmployeeFollowUpEventDetail.messages.errorGettingSingleQuiz"
              )
            );
          }
        } else if (res.status === 404) {
          AdnMessageError(
            t("manageEmployeeFollowUpEventDetail.messages.quizNotSetForEvent")
          );
        } else {
          AdnMessageError(
            t("manageEmployeeFollowUpEventDetail.messages.errorGettingQuiz")
          );
        }
      })
      .catch((e) => {
        AdnMessageError(
          t("manageEmployeeFollowUpEventDetail.messages.errorGettingQuiz")
        );
      });
  };

  const getUserData = async () => {
    let HRList = [];
    let ManagerList = [];
    await GetUserByDepartmentId(Departement.HumanResources).then((res) => {
      if (res.status === 200) {
        HRList = res.data.result;
      }
    });
    await GetUserByDepartmentId(Departement.Manager).then((res) => {
      if (res.status === 200) {
        ManagerList = res.data.result;
      }
    });

    setUsers(HRList.concat(ManagerList));
  };

  const updateEmployeeFollowUp = async (values) => {
    setSubmitLoading(true);
    //debugger
    values.id = parseInt(id);
    values.employeeId = initValues.employeeId;
    values.followUpEventId = initValues.followUpEventId;
    values.employeeName = initValues.employeeName;
    values.eventType = initValues.eventType;
    values.doneByName = initValues.doneByName;
    values.authenticatedId = initValues.authenticatedId;
    //null or not assigned or canceled keep value
    values.status =
      values.status === null || initValues.status === 0 || initValues.status === 3
        ? initValues.status
        : values.status;
    values.date =
      values.date === null ? null : values.date.format("YYYY-MM-DD");

    const res = await updateEmployeeFollowUpEvent(values);

    if (res.data.errors === null) {
      navigate(-1);
      AdnMessageSuccess();
    } else {
      setSubmitLoading(false);
      // AdnMessageError();
      const errors = res.data.errors;

      errors.forEach((error) => {
        const errorMessage = error.message;
        AdnMessageError(errorMessage);
      });
    }
  };

  const handleFinish = async (values) => {
    await updateEmployeeFollowUp(values);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSaveQuiz = async (values) => {
    const answers = prepareAnswers(values);
    await consultantQuizAnswers(answers)
      .then((res) => {
        if (res.status === 200) {
          if (showMessage) {
            AdnMessageSuccess();
          }
          getEmployeeFollowUpEvent();
        } else if (res && res.data && res.data.errors) {
          res.data.errors.map((e) => {
            AdnMessageError(e.message);
          });
        } else {
          AdnMessageError(
            t(
              "manageEmployeeFollowUpEventDetail.messages.errorSavingQuizAnswers"
            )
          );
        }
      })
      .catch((e) => {
        AdnMessageError(
          t("manageEmployeeFollowUpEventDetail.messages.errorSavingQuizAnswers")
        );
      });
  };

  const prepareAnswers = (values) => {
    let answers = {};
    answers.answerId = quizData.answerId;
    answers.isSubmitted = values.isSubmiting || false;
    answers.isEmployeeAnswer = false;

    const questionAnswers = [];
    quizData &&
      quizData.groups.map((grp) => {
        grp.questions.map((qst) => {
          // only the supervisor answers the questions
          if (
            qst.answeredBy === AnsweredBy.Supervisor ||
            qst.answeredBy === AnsweredBy.Both
          ) {
            let name = `grp_${grp.id}_qst_${qst.id}`;
            let answerValue = null;
            let answerIsNotApplicable = false;
            answerIsNotApplicable = values[name + NotApplicableSuffix] || false;
            if (answerIsNotApplicable === false) {
              answerValue =
                values[name] !== null && values[name] != undefined
                  ? values[name].toString()
                  : undefined;
            }
            // get QuestionAnswerId
            let questionAnswerId = 0;
            if (
              quizData.questionAnswers &&
              quizData.questionAnswers.length > 0
            ) {
              let questionAnswer = quizData.questionAnswers.find(
                (x) =>
                  x.questionId === qst.id &&
                  x.isEmployeeAnswer === answers.isEmployeeAnswer
              );
              // if it's undefinned it's because only the supervisor has to answer the question (evaluation event)
              if (questionAnswer) {
                questionAnswerId = questionAnswer.id;
              }
            }
            questionAnswers.push({
              id: questionAnswerId,
              answerId: quizData.answerId,
              questionId: qst.id,
              answer: answerValue,
              isNotApplicable: answerIsNotApplicable,
            });
          }
        });
      });
    answers.questionAnswers = questionAnswers;
    return answers;
  };

  const handleAssignToSupervisor = async () => {
    let employeeFollowUpEventId = parseInt(id);
    let doneById = getAuthenticatedUserId();
    await assignToSupervisor({ employeeFollowUpEventId, doneById })
      .then((res) => {
        if (res.status === 200) {
          getEmployeeFollowUpEvent();
          AdnMessageSuccess(
            t(
              "manageEmployeeFollowUpEventDetail.messages.quizAssignedToSupervisorSuccess"
            )
          );
        } else if (res && res.data && res.data.errors) {
          res.data.errors.map((e) => {
            AdnMessageError(e.message);
          });
        } else {
          AdnMessageError(
            t(
              "manageEmployeeFollowUpEventDetail.messages.errorAssigningToSupervisor"
            )
          );
        }
      })
      .catch(() => {
        AdnMessageError(
          t(
            "manageEmployeeFollowUpEventDetail.messages.errorAssigningToSupervisor"
          )
        );
      });
  };

  const handleIsUserRH = async () => {
    const UserId = getAuthenticatedUserId();
    let HRList = [];

    const res = await GetUserByDepartmentId(Departement.HumanResources);
    if (res.status === 200) {
      HRList = res.data.result;
    }

    const hasUserId = HRList.some((item) => item.id == UserId);

    if (hasUserId) {
      setIsUserRH(true);
    }
  };

  const redirectToCriticalSituation = (eventType) => {
    const employeeId = initValues.employeeId;
    window.location.href = AppRoutes.criticalSituation.path.concat(
      `?origin=${eventType}&employeeId=${employeeId}`
    );
  };

  const status = [
    {
      id: 1,
      name: t("manageEmployeeFollowUpEventDetail.status.notDone"),
    },
    {
      id: 2,
      name: t("manageEmployeeFollowUpEventDetail.status.done"),
    },
  ];

  return (
    <EmployeeFollowUpEventDetailListForm
      readonly={readonlyQuiz}
      formEvent={formEvent}
      initValues={initValues}
      handleFinish={handleFinish}
      handleCancel={handleCancel}
      users={users}
      loading={loading}
      submitLoading={submitLoading}
      quizData={quizData}
      handleSaveQuiz={handleSaveQuiz}
      quizAnswersValues={quizAnswersValues}
      handleAssignToSupervisor={handleAssignToSupervisor}
      isUserRH={isUserRH}
      setShowMessage={setShowMessage}
      disableSatisfactionLevel={disableSatisfactionLevel}
      handleRedirect={redirectToCriticalSituation}
      status={status}
    />
  );
};

export default ManageEmployeeFollowUpEventDetailListPage;
